// Si no tengo acceso al localStorage, uso una implementación en memoria

interface Storage {
	getItem(key: string): Nullable<string>;
	setItem(key: string, value: string): void;
	removeItem(key: string): void;
}

const storage: Storage = typeof window !== 'undefined' && window.localStorage
	? window.localStorage
	: (function () {
		const s: any = {};
		return {
			getItem(key: string): string {
				return s[key] || null;
			},
			setItem(key: string, value: string) {
				s[key] = value;
			},
			removeItem(key: string) {
				delete s[key];
			}
		};
	})();

export default storage;

